import '@omnitracs/walkme-component';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { NotSignedInError } from '@ot/shared/utils';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => {
    //NotSignedInError is thrown if the app is loaded at first and user is not signed in
    //it should not be an app error so we do not want to log it.
    if (!(err instanceof NotSignedInError)) {
      console.error(err);
    }
  });
